import { render, staticRenderFns } from "./NewPhone.vue?vue&type=template&id=739e1a47&scoped=true&"
import script from "./NewPhone.vue?vue&type=script&lang=js&"
export * from "./NewPhone.vue?vue&type=script&lang=js&"
import style0 from "./NewPhone.vue?vue&type=style&index=0&id=739e1a47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e1a47",
  null
  
)

export default component.exports